import { render, staticRenderFns } from "./ConfigureRelatedDocumentLinks.vue?vue&type=template&id=7ec64fa8&scoped=true&"
import script from "./ConfigureRelatedDocumentLinks.vue?vue&type=script&lang=ts&"
export * from "./ConfigureRelatedDocumentLinks.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigureRelatedDocumentLinks.vue?vue&type=style&index=0&id=7ec64fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec64fa8",
  null
  
)

export default component.exports